import React from "react";
import { useParams, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getAgentBySlug } from "@/lib/agents";
import { AlertTriangle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

const SubscriptionGuard: React.FC = () => {
  const { agentSlug } = useParams<{ agentSlug: string }>();
  const { subscriptions } = useAuth();

  const agent = getAgentBySlug(agentSlug);

  if (!agent) {
    // Agent doesn't exist, maybe redirect to dashboard or show 404
    return <Navigate to="/dashboard" replace />;
  }

  const isSubscribed = subscriptions.includes(agent.slug);

  if (!isSubscribed) {
    // User is not subscribed to this agent
    return (
      <div className="flex items-center justify-center h-full">
        <Card className="w-full max-w-lg text-center">
          <CardHeader>
            <CardTitle className="flex items-center justify-center text-destructive">
              <AlertTriangle className="mr-2 h-6 w-6" />
              Acceso Denegado
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p>
              No tienes una suscripción activa para el agente "
              <span className="font-semibold">{agent.name}</span>".
            </p>
            <p className="text-sm text-muted-foreground">
              Por favor, actualiza tu plan para acceder a esta funcionalidad.
            </p>
            <Button onClick={() => window.history.back()}>Volver</Button>
            {/* Optionally add a link to the subscription/billing page */}
            {/* <Button variant="link">Ver Planes</Button> */}
          </CardContent>
        </Card>
      </div>
    );
  }

  // User is subscribed, render the specific agent dashboard component
  return <Outlet />;
};

export default SubscriptionGuard;
